module.exports = __webpack_public_path__ + "img/sendmessage.91779613.svg";